import styled, { css } from 'styled-components';
import { Colors } from '../../colors';
export const List = styled.ul `
  display: flex;
  list-style: none;
  padding: 0;

  & > * + * {
    margin-left: 8px;
  }
`;
const itemButtonSize = {
    small: css `
    padding: 0 8px;
    height: 24px;
  `,
    regular: css `
    padding: 0 16px;
    height: 32px;
  `,
};
export const ItemButton = styled.button.attrs({
    type: 'button',
}) `
  display: flex;
  align-items: center;

  border-radius: 16px;
  outline: none;

  ${({ $size }) => itemButtonSize[$size || 'regular']};

  font-weight: 400;
  font-size: 16px;
  line-height: 1.5;
  color: ${Colors.GS600};

  ${({ $isActive }) => $isActive &&
    css `
      background: ${Colors.GS1000};
      color: ${Colors.GS100};
      pointer-events: none;
    `};

  ${({ $isActive }) => !$isActive &&
    css `
      &:hover {
        background: ${Colors.GS200};
      }
    `};
`;
